import React from 'react';
import { Inspect as InspectComp } from '../templates/inspect';
import { LinkComponent } from '../atoms/link-component';
import { Row } from '../atoms/row';
export const InspectPlugs = () => {
  return (
    <>
      <h1>Inspect Plugs</h1>

      <Row gap={1}>
        <LinkComponent to="/inspect">Home</LinkComponent>
        <LinkComponent to="/inspect/inverter">Inverter</LinkComponent>
        <LinkComponent to="/inspect/wallbox">Wallbox</LinkComponent>
        <LinkComponent to="/inspect/heat-pump">Heat pump</LinkComponent>
        <LinkComponent to="/inspect/mqtt">MQTT</LinkComponent>
        <LinkComponent to="/inspect/plugs">Plugs</LinkComponent>
        <LinkComponent to="/inspect/spot">Spot</LinkComponent>
        <LinkComponent to="/inspect/plc">PLC</LinkComponent>
      </Row>

      <InspectComp
        variableIds={[
          'MQTT_CLOUD_INSTALL',
          'MQTT_CLOUD_ADDRESS',
          'MQTT_CLOUD_LAST_MESSAGE_AT',
          'MQTT_CLOUD_CONNECTED',
          'MQTT_CLOUD_DEVICES',
          'MQTT_CLOUD_DEVICES_STATUS',
          'CLOUD_PLUGS_INSTALL',
        ]}
      />
    </>
  );
};
export default InspectPlugs;
